module.exports = __webpack_public_path__ + "img/assigned-newDot.4ab6ffa7.svg";